module.exports = __webpack_public_path__ + "img/95.f75ab9c5.png";